<template>
  <div class="login-page">
    <div class="login-box">
      <div class="login-title">
        <h1>
          <img src="@/assets/images/logo.png" alt="" /><br />
          {{ t('service_name') }}<br />
          {{ t('app_name') }}
        </h1>
      </div>
      <form @submit.prevent="login">
        <div v-if="errors.length">
          <ul>
            <li class="error-msg" v-for="error in errors" :key="error.key">
              {{ error.msg }}
            </li>
          </ul>
        </div>
        <div>
          <p>
            <v-text-field
              :label="t('label.construct_id')"
              variant="outlined"
              v-model="id"
              bg-color="#FFF"
              required
            ></v-text-field>
          </p>
          <p id="pw-area">
            <v-text-field
              :type="pwType"
              :append-inner-icon="pwType == 'text' ? 'mdi-eye' : 'mdi-eye-off'"
              :label="t('label.password')"
              variant="outlined"
              v-model="pw"
              bg-color="#FFF"
              required
              @click:append-inner="togglePwType"
            >
            </v-text-field>
          </p>
          <p v-if="!loading">
            <v-btn type="submit" color="primary" class="login-btn">{{
              t('btn.login')
            }}</v-btn>
          </p>
          <p v-if="loading">
            <v-btn type="submit" color="primary" class="login-btn" :disabled="loading">
              <div class="loading"></div>
            </v-btn>
          </p>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { loginView } from '@/scripts/LoginView';

const { t } = useI18n();
const router = useRouter();
const route = useRoute();

const errors = ref([] as { key: string; msg: string }[]);
const id = ref('');
const pw = ref('');
const pwMask = ref(true);
const pwType = pwMask.value ? ref('password') : ref('text');
const loading = ref(false);

if (route.query.ref !== undefined) {
  errors.value.push({
    key: 'timeout',
    msg: t('err.timeout'),
  });
}

onMounted(async (): Promise<void> => {
  // ログイン情報をパスパラメータから取得できる場合は自動ログイン
  if (route.params.id && route.params.pw) {
    id.value = route.params.id as string;
    pw.value = route.params.pw as string;
    await login();
  }
});

// パスワード表示切替
const togglePwType = (): void => {
  pwMask.value = !pwMask.value;
  pwType.value = pwMask.value ? 'password' : 'text';
};

// ログイン処理
const login = async (): Promise<void> => {
  loading.value = true;
  errors.value = [];
  try {
    await loginView.login(id.value, pw.value);
    router.push('/camList');
  } catch (error) {
    loading.value = false;
    errors.value.push({
      key: 'auth_error',
      msg: t('err.auth_error'),
    });
  }
};
</script>

<style scoped>
/* 共通のスタイル */
.login-title {
  margin: 0 0 24px;
}
.login-page {
  background: rgb(64, 159, 255);
  background: linear-gradient(
    0deg,
    rgba(83, 216, 221, 1) 0%,
    rgba(64, 159, 255, 1) 100%
  );
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-box h1 img {
  width: 100px;
  height: auto;
  padding-bottom: 0.2em;
}

.loading {
  width: 40px;
  height: 40px;
  margin: 1px auto;
  border: 4px #ddd solid;
  border-top: 4px rgb(83, 216, 221) solid;
  border-radius: 50%;
  animation: sp-anime 1s infinite linear;
}
@keyframes sp-anime {
  100% {
    transform: rotate(360deg);
  }
}

/* レスポンシブ対応(スマホ) */
@media screen and (max-width: 600px) {
  .login-box {
    width: 350px;
    margin: auto;
  }
  .login-box h1 {
    text-align: center;
    color: #00000080;
    vertical-align: bottom;
    font-size: 1.5rem;
  }
  .login-box button {
    width: 100%;
    display: block;
    font-size: 1.8rem;
    padding: 0.7rem 0 3.1rem;
    margin: 0;
  }
  .error-msg {
    color: red;
    font-size: 0.8rem;
    margin-bottom: 10px;
    margin-left: 2rem;
  }
}

/* レスポンシブ対応(PC) */
@media only screen and (min-width: 601px) {
  .login-box {
    width: 400px;
    margin: auto;
  }
  .login-box h1 {
    text-align: center;
    color: #00000080;
    vertical-align: bottom;
    font-size: 2rem;
  }
  .login-box button {
    width: 100%;
    display: block;
    font-size: 2rem;
    padding: 0.7rem 0.9rem 3.3rem;
    margin: 0.5rem 0;
  }
  .error-msg {
    color: red;
    font-size: 1rem;
    margin-bottom: 16px;
  }
}
</style>
